import React from 'react';
import './About.css';
import { FaBook, FaLanguage, FaUsers, FaGlobe, FaGraduationCap, FaHandshake, FaFacebook, FaInstagram, FaEnvelope, FaPhone } from 'react-icons/fa';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-hero">
        <h1>About Learn Pulaar</h1>
        <p>Preserving and sharing the rich heritage of the Pulaar language</p>
      </div>

      <div className="about-content">
        <section className="about-section mission">
          <div className="section-icon">
            <FaBook />
          </div>
          <div className="section-content">
            <h2>Our Mission</h2>
            <p>Learn Pulaar is dedicated to preserving and promoting the Pulaar language, making it accessible to learners worldwide. We believe in the power of language to connect cultures and preserve heritage.</p>
          </div>
        </section>

        <section className="about-section vision">
          <div className="section-icon">
            <FaGlobe />
          </div>
          <div className="section-content">
            <h2>Our Vision</h2>
            <p>To become the leading platform for Pulaar language learning, fostering cultural understanding and creating a global community of Pulaar speakers and enthusiasts.</p>
          </div>
        </section>

        <section className="about-section features">
          <h2>What We Offer</h2>
          <div className="offerings">
            <div className="offering">
              <div className="offering-icon">📚</div>
              <h3>Comprehensive Learning</h3>
              <p>Access a wide range of Pulaar phrases, vocabulary, and grammar lessons structured for all learning levels.</p>
            </div>
            <div className="offering">
              <div className="offering-icon">🎯</div>
              <h3>Interactive Quizzes</h3>
              <p>Test your knowledge with engaging quizzes and track your progress as you learn.</p>
            </div>
            <div className="offering">
              <div className="offering-icon">🔊</div>
              <h3>Audio Pronunciation</h3>
              <p>Learn correct pronunciation with native speaker audio recordings for every phrase.</p>
              <span className="coming-soon-badge">Coming Soon</span>
            </div>
            <div className="offering">
              <div className="offering-icon">📱</div>
              <h3>Mobile Learning</h3>
              <p>Learn on the go with our iOS app, featuring offline access and progress tracking.</p>
            </div>
            <div className="offering">
              <div className="offering-icon">🎮</div>
              <h3>Interactive Learning Tools</h3>
              <p>Engage with interactive exercises, word matching games, and real-time feedback to enhance your learning experience.</p>
              <span className="coming-soon-badge">Coming Soon</span>
            </div>
            <div className="offering">
              <div className="offering-icon">🌍</div>
              <h3>Cultural Immersion</h3>
              <p>Discover Pulaar culture through traditional stories, ceremonies, and cultural insights integrated into your learning journey.</p>
              <span className="coming-soon-badge">Coming Soon</span>
            </div>
          </div>
        </section>

        <section className="about-section team">
          <h2>Our Team</h2>
          <div className="team-content">
            <p>We are a dedicated team of language enthusiasts, educators, and technology experts working together to make Pulaar language learning accessible and enjoyable for everyone.</p>
            <div className="team-values">
              <div className="value-item">
                <h3>Passion</h3>
                <p>We are passionate about preserving and sharing the Pulaar language</p>
              </div>
              <div className="value-item">
                <h3>Quality</h3>
                <p>We maintain high standards in our content and learning materials</p>
              </div>
              <div className="value-item">
                <h3>Innovation</h3>
                <p>We continuously improve our platform with new features and content</p>
              </div>
            </div>
          </div>
        </section>

        <section className="about-section social">
          <h2>Join Our Community</h2>
          <div className="social-content">
            <p>Connect with us on social media to stay updated with the latest learning resources, cultural events, and community activities.</p>
            <div className="social-cta">
              <a 
                href="https://www.facebook.com/pulaarApps/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="facebook-button"
              >
                <FaFacebook className="social-icon" />
                Follow Us on Facebook
              </a>
              <a 
                href="https://www.instagram.com/pulaarapps/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="instagram-button"
              >
                <FaInstagram className="social-icon" />
                Follow Us on Instagram
              </a>
            </div>
          </div>
        </section>

        <section className="about-section contact">
          <h2>Get in Touch</h2>
          <div className="contact-grid">
            <div className="contact-info">
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <div>
                  <h3>Email Us</h3>
                  <p>info@learnpulaar.com</p>
                </div>
              </div>
            </div>
            <div className="contact-cta">
              <p>Have questions or suggestions? We'd love to hear from you!</p>
              <a href="/contact" className="contact-button">Contact Us</a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About; 